import { GenerateId } from "../util";
import GameObject from "./GameObject";
import { Time } from "./Time";

export default class MonoBehavior {

    id: string = GenerateId();
    gameObject: GameObject;
    born = Time.time;

    get engine() { return this.gameObject.engine; }
    get ctx() { return this.engine.ctx; }
    get timeAlive() { return Time.time - this.born; }
    get transform() { return this.gameObject.transform; }

    constructor(gameObject: GameObject) {
        this.gameObject = gameObject;
    }

    Equals(other: MonoBehavior) {
        return this.id === other.id;
    }

    Init() {
        
    }

    Start() {

    }

    Update() {

    }

    LateUpdate() {

    }

    Draw() {

    }

    DrawGizmos() {
        
    }

}